import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import {
  FaLinkedin,
  FaTelegram,
  // FaTelegramPlane,
  // FaTwitter,
  FaGithub,
  FaMedium,
  FaLink,
  FaDesktop,
} from "react-icons/fa";
import "./App.css";

import HomePage from "./HomePage";
import ResumePage from "./resume";
import PortfolioPage from "./portfolio";
import StartupPage from "./startup";
import ContactPage from "./contactForm";
import AboutMe from "./aboutMe";
import Skills from "./Skills";
import SpotifyPage from "./SpotifyPage";
import PodcastPage from "./PodcastPage";
import NotFoundPage from "./NotFoundPage";
import MediaPage from "./MediaPage";
import SideBar from "./components/Sidebar.js";
import TopBar from "./components/TopBar.js";
import LinkTree from "./linktree";
import DebugPage from "./debug";
import Travel from "./Travel";
import FractalPage from "./FractalPage";
import ClipboardDemo from "./components/ClipboardDemo";
import KaminariShareExtractor from "./components/KaminariShareExtractor";
// import YoutubePlayerWidget from "./components/YoutubePlayerWidget";
import VisionBoardPage from "./VisionBoardPage";
import MoviesPage from "./MoviesPage";
import Tamagotchi from "./Tamagotchi";
import RyujinImages from "./RyujinImages.js";
import FavoriteOS from "./FavoriteOS.js";
// import AllAppsPage from "./components/AllAppsPage";
// import Stats from "./Stats";
import GenerativeMusic from "./GenerativeMusic";
// import CountdownPage from "./CountdownPage";
// import ValorantPage from "./ValorantPage";
// import MusicPlayerTest from "./MusicPlayerTest";
// import { color } from "three/tsl";
// import KolibriOS from "./KolibriOS";
import MusicPlayer from "./MusicPlayer.js";
import SearchQueryGenerator from "./SearchQueryGenerator";
import SkitPage from "./SkitPage.js";
import PunchCardPage from "./PunchCardPage";
import FreelancePage from "./FreelancePage";
import ApiMonitor from "./ApiMonitor";
import SSRCheck from "./SSRCheck";
import CuneiformPage from "./CuneiformPage";
import NetworkInfoPage from "./NetworkInfoPage";
import PingPage from "./PingPage";
import KeyboardTest from "./KeyboardTest";
// import IranPage from "./IranPage";
// import RotationCursor from "./components/RotationCursor";
// import useCustomCursor from "./hooks/useCustomCursor";
// import AkiraPage from "./AkiraPage.js";

const footerStyles = {
  position: "fixed",
  bottom: 0,
  left: 0,
  width: "100%",
  background:
    "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.5) 20% , rgba(0,0,0,0.7) 40%, rgba(0,0,0,0.8) 60%, rgba(0,0,0,0.9) 80%, rgb(0, 0, 0) 100%)",
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  color: "#ffffffff",
  padding: "10px 0",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  transition: "all 0.5s ease-in-out",
  zIndex: 9,
  fontFamily: "monospace",
};

const NewFooter = () => {
  return (
    <footer style={footerStyles}>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {/* <img
          src="/The Guardian.png"
          alt="Guardian Icon"
          style={{ height: "20px", filter: "brightness(0) invert(1)" }}
        /> */}
        {/* <p> ダニアル </p> */}
        {/* <p> the 21 </p> */}
        <p> Let all that you do, be done in love </p>
        {/* https://www.reddit.com/r/videos/comments/3h0it3/the_onion_koko_parody_scientists_teach_gorilla_it/ */}
      </div>
      <div style={{ display: "flex" }}>
        <a
          href="https://t.me/DanialMDev"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaTelegram
            style={{ margin: "0 10px", color: "#f0f0f0" }}
            size={20}
          />
        </a>
        <a
          href="https://www.linkedin.com/in/danial-mohammadzadeh/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin
            style={{ margin: "0 10px", color: "#f0f0f0" }}
            size={20}
          />
        </a>
        <a
          href="https://medium.danials.space"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaMedium style={{ margin: "0 10px", color: "#f0f0f0" }} size={20} />
        </a>
        <a
          href="https://github.com/danial2026"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaGithub style={{ margin: "0 10px", color: "#f0f0f0" }} size={20} />
        </a>
        {/* <a
          href="https://danials.org/desktop"
          target="_blank"
          rel="noopener noreferrer"
          style={{ margin: "0 10px", color: "#f0f0f0", textDecoration: "none" }}
        >
          <FaDesktop style={{ color: "#f0f0f0" }} size={20} />
        </a> */}
        <Link to="/links" className="sidebar-link" title="Links">
          <FaLink style={{ margin: "0 10px", color: "#f0f0f0" }} size={20} />
        </Link>
      </div>
    </footer>
  );
};

const FloatingButton = () => {
  useEffect(() => {
    if (!document.getElementById("floating-btn-glow-monochrome-styles")) {
      const style = document.createElement("style");
      style.id = "floating-btn-glow-monochrome-styles";
      style.textContent = `
        .floating-btn {
          position: fixed;
          bottom: 20px;
          right: 20px;
          height: 60px;
          padding: 0 20px;
          border-radius: 20px;
          background-color: rgba(255, 255, 255, 0.05);
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          gap: 12px;
          color: var(--text-color);
          font-size: 18px;
          font-weight: 600;
          // cursor: pointer;
          transition: all 0.3s ease;
          z-index: 1000;
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          text-decoration: none;
          user-select: none;
          white-space: nowrap;
          border: 2px solid transparent;
          background-clip: padding-box;
          overflow: visible;
          // cursor: url("the-weapon.png"), auto;
        }

        /* Monochrome glowing border */
        .floating-btn::before {
          content: "";
          position: absolute;
          top: -3px;
          left: -3px;
          right: -3px;
          bottom: -3px;
          border-radius: 22px;
          background-size: 1000% 1000%;
          animation: glowing-border-monochrome 10s linear infinite;
          z-index: -1;
          filter: blur(8px);
          opacity: 0.6;
        }

        /* Smoke flicker glow effect - subtle grey/white */
        .floating-btn::after {
          content: "";
          position: absolute;
          top: -6px;
          left: -6px;
          right: -6px;
          bottom: -6px;
          border-radius: 26px;
          background: radial-gradient(
            circle,
            rgba(255, 255, 255, 0.06),
            transparent 70%
          );
          filter: blur(12px);
          animation: smoke-flicker-monochrome 4s ease-in-out infinite;
          opacity: 0.35;
          z-index: -2;
        }

        /* Star sparkles - white/grey only */
        .floating-btn .star {
          position: absolute;
          width: 4px;
          height: 4px;
          background: #eee;
          box-shadow:
            0 0 5px 1.5px #ddd,
            0 0 10px 3px #bbb;
          animation: sparkle-monochrome 2.5s linear infinite;
          opacity: 0.8;
          filter: drop-shadow(0 0 1.5px #fff);
        }

        /* Stars positioned around edges */
        .floating-btn .star:nth-child(1) {
          top: 4px;
          left: 12px;
          animation-delay: 0s;
        }
        .floating-btn .star:nth-child(2) {
          top: 10px;
          right: 16px;
          animation-delay: 0.7s;
        }
        .floating-btn .star:nth-child(3) {
          bottom: 8px;
          left: 18px;
          animation-delay: 1.4s;
        }
        .floating-btn .star:nth-child(4) {
          bottom: 12px;
          right: 10px;
          animation-delay: 2.1s;
        }
        .floating-btn .star:nth-child(5) {
          top: 20px;
          left: 28px;
          animation-delay: 2.8s;
        }

        @keyframes glowing-border-monochrome {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 100% 50%;
          }
        }

        @keyframes smoke-flicker-monochrome {
          0%, 100% {
            opacity: 0.35;
          }
          50% {
            opacity: 0.15;
          }
        }

        @keyframes sparkle-monochrome {
          0%, 100% {
            opacity: 0.8;
            transform: scale(1);
          }
          50% {
            opacity: 0.3;
            transform: scale(0.6);
          }
        }

        .floating-btn:hover {
          background-color: rgba(255, 255, 255, 0.15);
          border-color: var(--primary-color);
          box-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
          transform: translateY(-4px);
          color: var(--primary-color);
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <a
      href="https://danials.org/desktop"
      target="_blank"
      rel="noopener noreferrer"
      className="floating-btn"
      aria-label="Open Desktop View"
    >
      <FaDesktop style={{ fontSize: "24px", flexShrink: 0 }} />
      <span>Open Desktop View</span>

      {/* Star sparkle elements */}
      <span className="star" />
      <span className="star" />
      <span className="star" />
      <span className="star" />
      <span className="star" />
    </a>
  );
};
// const FloatingButton = () => {
//   return (
//     <a
//       href="https://danials.org/desktop"
//       target="_blank"
//       rel="noopener noreferrer"
//       className="floating-btn"
//       style={{
//         position: "fixed",
//         bottom: "20px",
//         right: "20px",
//         height: "60px",
//         padding: "0 20px",
//         borderRadius: "20px",
//         border: "1px solid rgba(255, 255, 255, 0.2)",
//         backgroundColor: "rgba(255, 255, 255, 0.05)",
//         boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
//         display: "flex",
//         alignItems: "center",
//         gap: "12px",
//         color: "var(--text-color)",
//         fontSize: "18px",
//         fontWeight: "600",
//         cursor: "pointer",
//         transition: "all 0.3s ease",
//         zIndex: 1000,
//         backdropFilter: "blur(8px)",
//         WebkitBackdropFilter: "blur(8px)",
//         textDecoration: "none",
//         userSelect: "none",
//         whiteSpace: "nowrap",
//       }}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
//         e.currentTarget.style.borderColor = "var(--primary-color)";
//         e.currentTarget.style.boxShadow = "0 4px 20px rgba(255, 255, 255, 0.3)";
//         e.currentTarget.style.transform = "translateY(-4px)";
//         e.currentTarget.style.color = "var(--primary-color)";
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
//         e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
//         e.currentTarget.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.1)";
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.color = "var(--text-color)";
//       }}
//       title="A macOS-style web desktop by Danial. Try out web apps, music, and more in a desktop-like environment."
//       aria-label="Open Desktop View"
//     >
//       <FaDesktop style={{ fontSize: "24px" }} />
//       <span>Open Desktop View</span>
//     </a>
//   );
// };

const backgroundStyle = {
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundAttachment: "fixed",
  height: "100%",
  minHeight: "100vh",
  boxSizing: "border-box",
};

const theme = {
  background: "#000000",
  text: "#FFFFFF",
  textSecondary: "#A0A0A0",
  primary: "#606060",
};

const AppInner = () => {
  // const [showTerminal, setShowTerminal] = useState(false);
  // useCustomCursor(); // Use the custom cursor hook
  const location = useLocation();

  // useEffect(() => {
  //   const handleKeyPress = (event) => {
  //     // Disable global shortcuts if on /keyboard route
  //     if (location.pathname === "/keyboard") return;

  //     if ((event.ctrlKey || event.metaKey) && event.key === "j") {
  //       event.preventDefault();
  //       setShowTerminal((prev) => !prev);
  //     }
  //   };

  //   document.addEventListener("keydown", handleKeyPress);
  //   return () => document.removeEventListener("keydown", handleKeyPress);
  // }, [location.pathname]);

  // const terminalStyles = {
  //   position: "fixed",
  //   bottom: 0,
  //   left: 0,
  //   width: "100%",
  //   height: "300px",
  //   border: 0,
  //   zIndex: 20,
  //   display: showTerminal ? "block" : "none",
  //   background: "none",
  //   paddingTop: "10px",
  // };

  // Check if the current route is /music
  const isMusicRoute = location.pathname === "/music";

  return (
    <div className="app" style={backgroundStyle}>
      {/* Light Beam Effect */}
      {/* <LightBeam /> */}

      {(() => {
        const hour = new Date().getHours();
        // Night time: 17 (5pm) to 6 (6am)
        if (hour >= 17 || hour < 6) {
          return <Particle />;
        }
        return null;
      })()}

      {/* Conditionally render TopBar */}
      {!isMusicRoute && <TopBar />}

      <div
        className="content"
        style={isMusicRoute ? { margin: 0, padding: 0 } : undefined}
      >
        {/* Conditionally render SideBar */}
        {!isMusicRoute && <SideBar />}

        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about-me" element={<AboutMe />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/skills" element={<Skills />} />
          <Route path="/startups" element={<StartupPage />} />
          <Route path="/spotify" element={<SpotifyPage />} />
          <Route path="/podcast" element={<PodcastPage />} />
          <Route path="/media" element={<MediaPage />} />
          <Route path="/linktree" element={<LinkTree />} />
          <Route path="/links" element={<LinkTree />} />
          <Route path="/debug" element={<DebugPage />} />
          <Route path="/debug/:paramName" element={<DebugPage />} />
          <Route path="/travel" element={<Travel />} />
          <Route path="/fractal" element={<FractalPage />} />
          <Route path="/clipboard" element={<ClipboardDemo />} />
          <Route path="/visionboard" element={<VisionBoardPage />} />
          <Route path="/movie" element={<MoviesPage />} />
          <Route path="/movies" element={<MoviesPage />} />
          <Route path="/tamagotchi" element={<Tamagotchi />} />
          <Route path="/ryujin" element={<RyujinImages />} />
          <Route path="/os" element={<FavoriteOS />} />
          <Route path="/regolith" element={<FavoriteOS />} />
          <Route path="/music-generator" element={<GenerativeMusic />} />
          <Route path="/share-extractor" element={<KaminariShareExtractor />} />
          {/* <Route path="/countdown" element={<CountdownPage />} /> */}
          {/* <Route path="/kolibri" element={<KolibriOS />} /> */}
          <Route path="/pink-white" element={<MusicPlayer />} />
          <Route path="/music" element={<MusicPlayer />} />
          <Route path="/search" element={<SearchQueryGenerator />} />
          <Route path="/skit" element={<SkitPage />} />
          <Route path="/punch-card" element={<PunchCardPage />} />
          <Route path="/freelance" element={<FreelancePage />} />
          <Route path="/api-monitor" element={<ApiMonitor />} />
          <Route path="/ssr" element={<SSRCheck />} />
          <Route path="/cuneiform" element={<CuneiformPage />} />
          <Route path="/secret" element={<CuneiformPage />} />
          <Route path="/network" element={<NetworkInfoPage />} />
          <Route path="/ping" element={<PingPage />} />
          <Route path="/keyboard" element={<KeyboardTest />} />
          {/* <Route path="/akira" element={<AkiraPage />} /> */}
          {/* <Route path="/valorant" element={<ValorantPage />} /> */}
          {/* <Route path="/stats" element={<Stats />} /> */}
          {/* <Route path="/iran" element={<IranPage />} /> */}
          {/* <Route path="/desktop" element={<AllAppsPage />} /> */}
          {/* <Route path="/set-meeting" element={<SetMeetingPage />} /> */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>

      {/* Conditionally render Footer */}
      {!isMusicRoute && (
        <nav>
          <NewFooter />
        </nav>
      )}

      {/* Floating Button */}
      {/* {!isMusicRoute && <FloatingButton />} */}

      {/* <iframe
        src="https://terminal.danials.space/"
        style={terminalStyles}
        className="terminal-iframe"
        title="Terminal"
        allowTransparency="true"
        frameBorder="0"
      /> */}

      {/* <RotationCursor /> */}
    </div>
  );
};

const App = () => (
  <Router>
    <AppInner />
  </Router>
);

export default App;

// Light Beam Component for the glowing effect
const Particle = () => {
  // PREDICTED night sky visible from Mashhad, Iran on December 25, 1999 at ~8:00 PM local time
  // These are educated estimates based on seasonal patterns and astronomical knowledge
  // NOT verified historical data - for exact positions, use professional astronomy software
  const mashhadWinterSky = [
    // PREDICTED Planet positions (educated estimates based on 1999 orbital mechanics)
    {
      id: 1,
      name: "Jupiter",
      x: 75,
      y: 45,
      magnitude: -2.0,
      size: 4.8,
      type: "planet",
    },
    {
      id: 2,
      name: "Saturn",
      x: 25,
      y: 60,
      magnitude: 0.5,
      size: 4.2,
      type: "planet",
    },
    {
      id: 3,
      name: "Venus",
      x: 20,
      y: 75,
      magnitude: -4.0,
      size: 4.9,
      type: "planet",
    },
    {
      id: 4,
      name: "Mars",
      x: 80,
      y: 70,
      magnitude: 1.5,
      size: 3.6,
      type: "planet",
    },
    {
      id: 5,
      name: "Mercury",
      x: 15,
      y: 85,
      magnitude: -0.5,
      size: 4.3,
      type: "planet",
    },

    // Winter Constellations - PREDICTED positions based on seasonal patterns
    // Orion (the Hunter) - dominates southern winter sky
    {
      id: 6,
      name: "Betelgeuse",
      x: 50,
      y: 55,
      magnitude: 0.4,
      size: 4.0,
      type: "star",
    },
    {
      id: 7,
      name: "Rigel",
      x: 52,
      y: 58,
      magnitude: 0.1,
      size: 4.1,
      type: "star",
    },
    {
      id: 8,
      name: "Bellatrix",
      x: 48,
      y: 52,
      magnitude: 1.6,
      size: 3.5,
      type: "star",
    },
    {
      id: 9,
      name: "Mintaka",
      x: 54,
      y: 56,
      magnitude: 2.2,
      size: 3.1,
      type: "star",
    },
    {
      id: 10,
      name: "Alnilam",
      x: 56,
      y: 57,
      magnitude: 1.7,
      size: 3.4,
      type: "star",
    },
    {
      id: 11,
      name: "Alnitak",
      x: 58,
      y: 58,
      magnitude: 1.9,
      size: 3.3,
      type: "star",
    },
    {
      id: 12,
      name: "Saiph",
      x: 50,
      y: 60,
      magnitude: 2.1,
      size: 3.2,
      type: "star",
    },

    // Taurus (the Bull) - above Orion in winter sky
    {
      id: 13,
      name: "Aldebaran",
      x: 60,
      y: 45,
      magnitude: 0.9,
      size: 3.9,
      type: "star",
    },
    {
      id: 14,
      name: "Elnath",
      x: 65,
      y: 43,
      magnitude: 1.7,
      size: 3.4,
      type: "star",
    },
    {
      id: 15,
      name: "Alcyone",
      x: 62,
      y: 47,
      magnitude: 2.9,
      size: 2.9,
      type: "star",
    },
    {
      id: 16,
      name: "Atlas",
      x: 64,
      y: 49,
      magnitude: 3.6,
      size: 2.3,
      type: "star",
    },
    {
      id: 17,
      name: "Electra",
      x: 66,
      y: 51,
      magnitude: 3.7,
      size: 2.2,
      type: "star",
    },

    // Gemini (the Twins) - east of Orion in winter
    {
      id: 18,
      name: "Castor",
      x: 70,
      y: 40,
      magnitude: 1.6,
      size: 3.5,
      type: "star",
    },
    {
      id: 19,
      name: "Pollux",
      x: 72,
      y: 42,
      magnitude: 1.2,
      size: 3.7,
      type: "star",
    },
    {
      id: 20,
      name: "Alhena",
      x: 74,
      y: 45,
      magnitude: 1.9,
      size: 3.3,
      type: "star",
    },
    {
      id: 21,
      name: "Wasat",
      x: 76,
      y: 47,
      magnitude: 3.5,
      size: 2.4,
      type: "star",
    },

    // Canis Major (the Great Dog) - below Orion
    {
      id: 22,
      name: "Sirius",
      x: 45,
      y: 70,
      magnitude: -1.5,
      size: 4.5,
      type: "star",
    },
    {
      id: 23,
      name: "Adhara",
      x: 43,
      y: 72,
      magnitude: 1.5,
      size: 3.6,
      type: "star",
    },
    {
      id: 24,
      name: "Wezen",
      x: 47,
      y: 74,
      magnitude: 1.8,
      size: 3.5,
      type: "star",
    },
    {
      id: 25,
      name: "Mirzam",
      x: 49,
      y: 76,
      magnitude: 2.0,
      size: 3.3,
      type: "star",
    },

    // Canis Minor (the Little Dog)
    {
      id: 26,
      name: "Procyon",
      x: 55,
      y: 65,
      magnitude: 0.4,
      size: 4.0,
      type: "star",
    },
    {
      id: 27,
      name: "Gomeisa",
      x: 57,
      y: 67,
      magnitude: 2.9,
      size: 2.9,
      type: "star",
    },

    // Auriga (the Charioteer) - high in northern winter sky
    {
      id: 28,
      name: "Capella",
      x: 80,
      y: 30,
      magnitude: 0.1,
      size: 4.1,
      type: "star",
    },
    {
      id: 29,
      name: "Menkalinan",
      x: 82,
      y: 33,
      magnitude: 1.9,
      size: 3.3,
      type: "star",
    },
    {
      id: 30,
      name: "Elnath",
      x: 84,
      y: 35,
      magnitude: 1.7,
      size: 3.4,
      type: "star",
    },

    // Perseus - winter constellation
    {
      id: 31,
      name: "Mirfak",
      x: 88,
      y: 40,
      magnitude: 1.8,
      size: 3.5,
      type: "star",
    },
    {
      id: 32,
      name: "Algol",
      x: 90,
      y: 42,
      magnitude: 2.1,
      size: 3.2,
      type: "star",
    },

    // Ursa Major (Big Dipper) - always visible in northern hemisphere
    {
      id: 33,
      name: "Dubhe",
      x: 15,
      y: 25,
      magnitude: 1.8,
      size: 3.5,
      type: "star",
    },
    {
      id: 34,
      name: "Merak",
      x: 18,
      y: 28,
      magnitude: 2.4,
      size: 3.0,
      type: "star",
    },
    {
      id: 35,
      name: "Phecda",
      x: 22,
      y: 32,
      magnitude: 2.4,
      size: 3.0,
      type: "star",
    },
    {
      id: 36,
      name: "Megrez",
      x: 25,
      y: 35,
      magnitude: 3.3,
      size: 2.5,
      type: "star",
    },
    {
      id: 37,
      name: "Alioth",
      x: 28,
      y: 38,
      magnitude: 1.8,
      size: 3.5,
      type: "star",
    },
    {
      id: 38,
      name: "Mizar",
      x: 32,
      y: 42,
      magnitude: 2.1,
      size: 3.2,
      type: "star",
    },

    // Additional winter stars
    {
      id: 39,
      name: "Aldebaran",
      x: 60,
      y: 45,
      magnitude: 0.9,
      size: 3.9,
      type: "star",
    },
    {
      id: 40,
      name: "Capella",
      x: 80,
      y: 30,
      magnitude: 0.1,
      size: 4.1,
      type: "star",
    },
  ];

  return (
    <div className="light-beam-container">
      <div className="random-particles">
        {mashhadWinterSky.map((star) => {
          const randomDelay = Math.random() * 0.5; // Random delay (0-0.5s)
          const randomDuration = 8 + Math.random() * 8; // Random duration (8-16s)

          return (
            <div
              key={star.id}
              className={`random-particle ${star.type}`}
              style={{
                "--delay": `${randomDelay}s`,
                "--duration": `${randomDuration}s`,
                "--size": `${star.size}px`,
                "--x": `${star.x}%`,
                "--y": `${star.y}%`,
                "--magnitude": star.magnitude,
              }}
              title={`${star.name} (${star.type}) - Magnitude: ${star.magnitude} - PREDICTED Dec 25, 1999`}
            ></div>
          );
        })}
      </div>
    </div>
  );
};

// Light Beam Component for the glowing effect
const LightBeam = () => {
  return (
    <div className="light-beam-container">
      <div className="light-beam"></div>
      <div className="light-beam-glow"></div>
      <div className="light-beam-particles"></div>
      <div className="floating-particles">
        {[...Array(8)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              "--delay": `${i * 1}s`,
              "--duration": `${6 + i * 1}s`,
              "--size": `${2 + i * 0.5}px`,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};
